var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconStarHalf = React.memo(function (props) {
    var color = props.color, filledOut = props.filledOut, filledColor = props.filledColor, rest = __rest(props, ["color", "filledOut", "filledColor"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: filledColor !== null && filledColor !== void 0 ? filledColor : color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", strokeLinejoin: "round", strokeLinecap: "round", filledOut: filledOut, filledColor: filledColor },
            React.createElement("path", { strokeWidth: "1", strokeOpacity: filledOut ? 1 : 0.7, style: { fill: "transparent" }, d: "M15.5,21.8l6.7,3.6l-1.3-7.5l5.4-5.3l-7.5-1.1l-3.3-6.8H15l-3.3,6.8l-7.5,1.1l5.4,5.3 l-1.3,7.5l6.7-3.6" }),
            React.createElement("path", { d: "M15,4.7l-3.3,6.8l-7.5,1.1l5.4,5.3l-1.3,7.5l6.7-3.6" }))));
});
export default IconStarHalf;
//# sourceMappingURL=IconStarHalf.js.map